/** Dot-path lookup with French fallback when Arabic missing. */
export function getByPath(tree, path) {
  if (tree == null || path == null) return undefined;
  const parts = String(path).split('.');
  let cur = tree;
  for (const p of parts) {
    if (cur == null || typeof cur !== 'object') return undefined;
    cur = cur[p];
  }
  return cur;
}

/** Replace `{placeholder}` occurrences in translated strings */
export function interpolate(template, vars) {
  if (template == null || typeof template !== 'string' || !vars) return template;
  return template.replace(/\{(\w+)\}/g, (_, k) =>
    vars[k] != null ? String(vars[k]) : `{${k}}`
  );
}
